import React from 'react';
import { Button } from 'react-bootstrap';

import { ReactComponent as EmptyProvders } from './empty-providers.svg';

const ImportEmptyProviders = () => {
  const goToProvidersPage = () => {
    window.location.href = '/admin/settings/providers';
  };

  return (
    <div className="services-import__step-empty">
      <EmptyProvders />
      <div className="title">No providers have been added yet</div>
      <Button onClick={goToProvidersPage}>Go to the Providers</Button>
    </div>
  );
};

export default ImportEmptyProviders;
